import { TranslateFunction } from '@pancakeswap/localization'
import { SalesSectionProps } from '.'

export const swapSectionData = (t: TranslateFunction): SalesSectionProps => ({
  headingText: t('Earn Passive Income'),
  bodyText: t('PheasantSwap offers a passive income feature that allows users to make their cryptocurrencies work for them.'),
  reverse: false,
  primaryButton: {
    to: '/farms',
    text: t('Explore'),
    external: false,
  },
  secondaryButton: {
    to: 'https://pheasantswap.com/',
    text: t('Learn'),
    external: true,
  },
  images: {
    path: '/images/home/earn/',
    attributes: [
			{ src: 'emptyImg', alt: t('') },
			{ src: 'emptyImg1', alt: t('') },
			{ src: 'emptyImg2', alt: t('') },
      { src: 'happy', alt: t('Pie chart') },
      // { src: 'stonks', alt: t('Stocks chart') },
      // { src: 'folder', alt: t('Folder with cake token') },
    ],
		extension: '.gif'
  },
})

export const earnSectionData = (t: TranslateFunction,chainName:any): SalesSectionProps => ({
  headingText: t('Hassle-free Trading'),
  bodyText: t('Trade anytoken on %chainName% in seconds, just by connecting your wallet.',{chainName}),
  reverse: true,
  primaryButton: {
    to: '/swap',
    text: t('Trade Now'),
    external: false,
  },
  secondaryButton: {
    to: 'https://pheasantswap.com/products/yield-farming',
    text: t('Learn'),
    external: true,
  },
  images: {
    path: '/images/home/trade/',
    attributes: [
      // { src: 'BNB', alt: t('BNB token') },
      { src: 'BTC', alt: t('BTC token') },
      { src: 'coin_pst_t', alt: t('CAKE token') },
    ],
		extension: '.webp'
  },
  
})

export const cakeSectionData = (t: TranslateFunction): SalesSectionProps => ({
  headingText: t('Thriving Community Ecosystem'),
  bodyText: t(
    'PheasantSwap boastsa thriving community ecosystem that supports govenance and development, with members collaborating to maintain and enhance the platform.',
  ),
  reverse: true,
  primaryButton: {
    // to: '/swap?outputCurrency=0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82&chainId=56',
    to: '/swap',
    text: t('Buy $PST'),
    external: false,
  },
  secondaryButton: {
    to: 'https://pheasantswap.com/tokenomics/cake',
    text: t('Learn'),
    external: true,
  },
  images: {
    path: '/images/home/cake/',
    attributes: [
		{ src: 'coin_pst', alt: t('Small 3d PST') }
      // { src: 'bottom-right', alt: t('Small 3d PST') },
      // { src: 'top-right', alt: t('Small 3d PST') },
      // { src: 'coin', alt: t('CAKE token') },
      // { src: 'top-left', alt: t('Small 3d PST') },
    ],
		extension: '.webp'
  },
})
